<div>
  <mat-form-field>
    <mat-label>Html Content</mat-label>
    <textarea [(ngModel)]="htmlContent" matInput></textarea>
  </mat-form-field>
</div>

<div class="button-right-container">
  <button (click)="cancel()" class="ibexfusion-raised-button" mat-button>cancel</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>ok</button>
</div>

